/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import monitoringService from 'infrastructure/serviceHandlers/Monitoring/Monitoring';
import { GetAllPaymentMethods } from 'services/api/paymentsApi';
import { TPaymentMethodsList, TPaymentMethodsState } from 'typings';

export const fetchPaymentMethods = createAsyncThunk(
  'user/paymentMethods',
  async (_payload, thunkAPI) => {
    try {
      const { data } = await GetAllPaymentMethods();
      // Spec ("List Payment Methods") returns `payment_method` — a singular key
      // holding the array. Default to an empty list when absent.
      return {
        default_payment_method: data.default_payment_method ?? '',
        payment_method: data.payment_method ?? []
      } as TPaymentMethodsList;
    } catch (error) {
      monitoringService.captureException(error, {
        tags: {
          feature: 'fetchPaymentMethods',
          error_type: 'api_error'
        }
      });
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialCardState: TPaymentMethodsState = {
  allPaymentMethods: [],
  isLoading: false
};

export const paymentMethodsSlice = createSlice({
  name: 'paymentMethods',
  initialState: initialCardState,
  reducers: {
    clearPaymentMethods: (state) => {
      state.allPaymentMethods = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allPaymentMethods = action.payload.payment_method;
      })
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPaymentMethods.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { clearPaymentMethods } = paymentMethodsSlice.actions;

export default paymentMethodsSlice.reducer;
